import first from "lodash/first"

export const createPreppedRoutePart = routePart =>
    routePart?.startsWith("/") ? routePart.substring(1) : routePart

const routeRegex = /(?:\/:environment\?)?\/editor/
export const getEditorPrefix = path =>
    path ? first(path.match(routeRegex)) : null
